module.exports = __webpack_public_path__ + "static/media/bridge.f3a4e500.svg";